import { scrollLock } from 'utils/node';
import { debounce } from 'lodash-es';

/**
 * Lightbox
 */

class Lightbox {
  constructor(node, ctx) {
    this.ctx = ctx;
    this.element = node;

    this.index = 0;

    // Selectors
    this.items = node.querySelectorAll('[data-item]');
    this.closeTriggers = node.querySelectorAll('[data-close]');
    this.prevTrigger = node.querySelector('[data-prev]');
    this.nextTrigger = node.querySelector('[data-next]');
    this.track = node.querySelector('[data-track]');

    this.ctx.on('lightbox:open', ({ index }) => {
      this.open(index);
    });

    this.clickEvent();
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);

    this.track.addEventListener('scroll', debounce(() => {
      if (this.track.scrollLeft === 0) this.prevTrigger.disabled = true;
      else this.prevTrigger.disabled = false;

      if ((this.track.scrollWidth - window.innerWidth) === this.track.scrollLeft) {
        this.nextTrigger.disabled = true;
      } else {
        this.nextTrigger.disabled = false;
      }
    }, 350));
  }

  addEventListeners() {
    document.addEventListener('keydown', this.keydownEvent);
  }

  removeEventListeners() {
    document.removeEventListener('keydown', this.keydownEvent);
  }

  clickEvent() {
    this.closeTriggers.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    if (this.prevTrigger) {
      this.prevTrigger.addEventListener('click', (e) => {
        e.preventDefault();

        this.goTo(this.index -= 1);
      });
    }

    if (this.nextTrigger) {
      this.nextTrigger.addEventListener('click', (e) => {
        e.preventDefault();

        this.goTo(this.index += 1);
      });
    }
  }

  keydownEvent(event) {
    if (event.key === 'Escape') this.close();
    if (event.key === 'ArrowLeft') this.goTo(this.index -= 1);
    if (event.key === 'ArrowRight') this.goTo(this.index += 1);
  }

  open(index) {
    this.index = Number(index);
    scrollLock(true);

    this.element.classList.add('is-open');
    this.element.setAttribute('aria-hidden', false);

    this.goTo(this.index);
    this.addEventListeners();
  }

  close() {
    this.element.classList.remove('is-open');
    this.element.setAttribute('aria-hidden', true);
    scrollLock(false);

    this.removeEventListeners();
  }

  goTo(newIndex) {
    this.index = Lightbox.clamp(newIndex, 0, this.items.length - 1);
    this.items[this.index].scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'center',
    });

    if (this.prevTrigger && this.index === 0) this.prevTrigger.disabled = true;
    else this.prevTrigger.disabled = false;

    if (this.nextTrigger && this.index === this.items.length - 1) this.nextTrigger.disabled = true;
    else this.nextTrigger.disabled = false;
  }

  static clamp(number, min, max) {
    return Math.min(Math.max(number, min), max);
  }
}

export default (node, ctx) => new Lightbox(node, ctx);
